<template>
    <div style="text-align:center;margin-bottom:20px">
        <Tabs>
          <TabPane label="散客">
            <div class="qrcode" ref="qrCodeUrl" :title="title"></div>
            <Spin size="large" fix v-if="spinShow1"></Spin>
          </TabPane>
<!--          <TabPane label="团体">-->
<!--            <div class="qrcode" ref="ttqrCodeUrl" :title="title"></div>-->
<!--            <Spin size="large" fix v-if="spinShow2"></Spin>-->
<!--          </TabPane>-->
        </Tabs>
        <div>请使用<span class="wxlogin">微信</span>扫码登录</div>
        <Divider />
    </div>
</template>

<script>
import Vue from 'vue'
import QRCode from 'qrcodejs2'
import { v4 } from 'uuid'
export default {
  data () {
    return {
      num: '',
      socket: '',
      title: null,
      spinShow1: true,
      spinShow2: true,
      ws: null
    }
  },
  created () {
    const that = this
    this.ws = new WebSocket(process.env.VUE_APP_WEBSOCKET)
    this.heartCheck = {
      timeout: 10000,
      timeoutObj: null,
      serverTimeoutObj: null,
      reset: function () {
        if (this.timeoutObj) clearTimeout(this.timeoutObj)
        if (this.serverTimeoutObj) clearTimeout(this.serverTimeoutObj)
        return this
      },
      start: function () {
        var self = this
        this.timeoutObj = setTimeout(function () {
          // 这里发送一个心跳，后端收到后，返回一个心跳消息，
          // onmessage拿到返回的心跳就说明连接正常
          const obj = {
            heartBeat: 'HeartBeat' + new Date()
          }
          if (that.ws) {
            if (that.ws.readyState===1) {
              that.ws.send(JSON.stringify(obj))
            }
          }
          // console.info('客户端发送心跳：' + new Date())
          self.serverTimeoutObj = setTimeout(function () { // 如果超过一定时间还没重置，说明后端主动断开了
            if (that.ws) that.ws.close() // 如果onclose会执行reconnect，我们执行ws.close()就行了.如果直接执行reconnect 会触发onclose导致重连两次
          }, self.timeout)
        }, this.timeout)
      }
    }
  },
  mounted () {
    setTimeout(() => {
      this.openWebsocket()
      this.creatQrCode()
      this.creatTtQrCode()
    }, 500)
  },
  destroyed () {
    this.socket.close()
  },
  methods: {
    openWebsocket () {
      if (window.WebSocket) {
        this.num = this._MathTand()
        this.socket = this.ws
        this.socket.onopen = this.websocketonopen()
        this.socket.onerror = this.websocketonerror
        this.socket.onmessage = this.websocketonmessage
        this.socket.onclose = this.websocketclose
      }
    },
    websocketonopen () {
      var wwaKey = this.num
      if (this.ws.readyState===1) {
        this.ws.send('{"transCode":"wwareq","wwaKey":"' + wwaKey + '"}')
      }
      // this.ws.send('{"transCode":"wwareq","wwaKey":"' + wwaKey + '"}')
      // console.log(new Date())
    },
    websocketonerror () {
      // console.log('连接出错')
    },
    websocketonmessage (e) {
      var wwaKey = this.num
      var jsonObj = JSON.parse(e.data)
      const redirect = this.$route.query.redirect
      // 判断是否是微信网页授权的业务
      // eslint-disable-next-line no-prototype-builtins
      if (jsonObj.hasOwnProperty('transCode') && jsonObj.hasOwnProperty('wwaKey')) {
        if (wwaKey === jsonObj.wwaKey) {
          // 微信网页授权业务建立websocket是否成功
          if (jsonObj.transCode === 'wwareq') {
            if (jsonObj.res === '0') {
              // TODO 这里是例子，具体连接成功之后的业务自己实现
              // console.log(JSON.stringify(jsonObj))
              // alert('websocket连接成功!')
            } else {
              // TODO 这里是例子，具体连接失败之后的业务自己实现
              alert('websocket连接失败!')
            }
            // 微信网页授权响应结果
          } else if (jsonObj.transCode === 'wwares') {
            // console.log(jsonObj)
            // Vue.ls.set('token', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyaWQiOiJvajl2cnYwMHNOYjkycUxvVHl4Z0dod0hWTHhZIiwidHlwZSI6IjAiLCJpYXQiOjE1OTQwOTE0MTYsImV4cCI6MTU5NDA5NTAxNn0.gVs2-Sdk2RWhZreB7ncCXd5sgPgKdalWgDlIKA_DKfs')
            Vue.ls.set('token', jsonObj.token)
            Vue.ls.set('refresh_token', jsonObj.refresh_token)
            Vue.ls.set('type', jsonObj.type)
            Vue.ls.set('headimgurl', jsonObj.headimgurl)
            Vue.ls.set('nickname', jsonObj.nickname)
            this.$store.dispatch('setToken', jsonObj.token)
            this.$emit('closeModal')
            // TODO 这里是例子，具体获取到授权token之后的业务自己实现
            // alert(JSON.stringify(jsonObj))
            // this.modal = false
          }
        }
      } else {
        // alert('其它业务不实现!')
        this.heartCheck.reset().start()
      }
    },
    websocketclose (e) { // 关闭
      // console.log('服务器关闭')
    },
    creatQrCode () {
      // const num = this._MathTand()
      // const url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf16488f084933f91&redirect_uri=http%3a%2f%2fauth.test.sjtickettech.com%2fwechat%2fwebpage%2fauthorization%2fnotify%2f&response_type=code&scope=snsapi_userinfo&state=wxf16488f084933f91,' + this.num + ',0#wechat_redirect'
      const url = `https://pc.xiangshantickets.com/login/pc-authorization.html?appid=${process.env.VUE_APP_APPID}&redirect_uri=${encodeURI(process.env.VUE_APP_REDIRECT_URI)}&response_type=code&scope=snsapi_userinfo&state=${process.env.VUE_APP_STATE},${this.num},0#wechat_redirect`
      // eslint-disable-next-line no-unused-vars
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: url,
        width: 200,
        height: 200,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
      this.spinShow1 = false
    },
    creatTtQrCode () {
      // const num = this._MathTand()
      // const url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf16488f084933f91&redirect_uri=http%3a%2f%2fauth.test.sjtickettech.com%2fwechat%2fwebpage%2fauthorization%2fnotify%2f&response_type=code&scope=snsapi_userinfo&state=wxf16488f084933f91,' + this.num + ',1#wechat_redirect'
      const url = `https://pc.xiangshantickets.com/login/pc-authorization.html?appid=${process.env.VUE_APP_APPID}&redirect_uri=${encodeURI(process.env.VUE_APP_REDIRECT_URI)}&response_type=code&scope=snsapi_userinfo&state=${process.env.VUE_APP_STATE},${this.num},1#wechat_redirect`
      // eslint-disable-next-line no-unused-vars
      var qrcode = new QRCode(this.$refs.ttqrCodeUrl, {
        text: url,
        width: 200,
        height: 200,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
      this.spinShow2 = false
    },
    _MathTand () {
      var num = ''
      // for (var i = 0; i < 6; i++) {
      //   num += Math.floor(Math.random() * 10)
      // }
      num = v4()
      return num
    }
  }
}
</script>

<style scoped lang="less">
.vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
}
.ivu-modal{
    top: 0;
}
.qrcode{
  margin-top:20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  min-height: 200px;
  min-width: 200px;
}
.wxlogin{
  font-size:16px;
  color:@font-red
}
</style>
